module.exports = __webpack_public_path__ + "media/images/escudo-32db916784f56a65b31e219def4d4d9c.png";